const CODIGO_OU_COMENTARIO_RE = /(```[\s\S]*?```|`[^`\n]*`)|<!--[\s\S]*?-->|<!--\s*(?:skill_|i18n)[\s\S]*$/g;

function limparString(texto) {
    if (typeof texto !== 'string' || !texto.includes('<!--')) {
        return texto;
    }

    let removeu = false;
    const limpo = texto.replace(CODIGO_OU_COMENTARIO_RE, (_bruto, codigo) => {
        if (codigo) return codigo;
        removeu = true;
        return '';
    });

    return removeu ? limpo.replace(/\s+$/, '') : limpo;
}

export function removerMarcadoresInternos(content) {
    if (Array.isArray(content)) {
        return content.map((bloco) =>
            bloco && bloco.type === 'text' && typeof bloco.text === 'string'
                ? { ...bloco, text: limparString(bloco.text) }
                : bloco
        );
    }
    return limparString(content);
}

const NUMERO_COM_ESPACO_RE = /(^|[^\d.,])(\d{1,3}(?:[ \u00a0\u202f]\d{3})+)(?!\d)((?:[.,]\d+)?)/g;
const TROCA_DE_ESPACO_RE = /[ \u00a0\u202f]/g;
const MOEDA_ANTES_RE = /(?:R\$|US\$|\$|€|£)\s*$/;
const UNIDADE_DEPOIS_RE = /^\s*[A-Za-zÀ-ÿ%]/;
const PIPE_ANTES_RE = /\|\s*$/;
const IDENTIFICADOR_ANTES_RE =
    /(?:^|[^A-Za-zÀ-ÿ])(?:telefone|tel|fone|celular|whatsapp|zap|phone|c[oó]digo|cod|c[oó]d|code|cep|cnpj|cpf|rg|id|protocolo|processo|pedido|nota|n[º°])\s*[:#-]?\s*$/i;
const PIPE_DEPOIS_RE = /^\s*\|/;
const CODIGO_RE = /(```[\s\S]*?```|`[^`\n]*`)/;

function separadorDeMilhar(idioma) {
    if (!idioma) return null;
    try {
        const grupo = new Intl.NumberFormat(idioma)
            .formatToParts(1234567)
            .find((parte) => parte.type === 'group');
        if (!grupo || /\s/.test(grupo.value)) return null;
        return grupo.value;
    } catch (e) {
        return null;
    }
}

function trocarMilharEmTrecho(trecho, separador) {
    return trecho.replace(NUMERO_COM_ESPACO_RE, (bruto, antes, numero, decimais, posicao, inteiro) => {
        const textoAntes = inteiro.slice(0, posicao + antes.length);
        const textoDepois = inteiro.slice(posicao + bruto.length);

        const junto =
            MOEDA_ANTES_RE.test(textoAntes) ||
            (UNIDADE_DEPOIS_RE.test(textoDepois) && !IDENTIFICADOR_ANTES_RE.test(textoAntes)) ||
            (PIPE_ANTES_RE.test(textoAntes) && PIPE_DEPOIS_RE.test(textoDepois));
        if (!junto) return bruto;

        return antes + numero.replace(TROCA_DE_ESPACO_RE, separador) + decimais;
    });
}

function normalizarString(texto, separador) {
    if (typeof texto !== 'string' || !texto) return texto;
    return texto
        .split(CODIGO_RE)
        .map((parte, i) => (i % 2 === 1 ? parte : trocarMilharEmTrecho(parte, separador)))
        .join('');
}

export function normalizarSeparadorMilhar(content, idioma) {
    const separador = separadorDeMilhar(idioma);
    if (!separador) return content;

    if (Array.isArray(content)) {
        return content.map((bloco) =>
            bloco && bloco.type === 'text' && typeof bloco.text === 'string'
                ? { ...bloco, text: normalizarString(bloco.text, separador) }
                : bloco
        );
    }
    return normalizarString(content, separador);
}
